exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-316e5d4e] {\n  color: #fff !important;\n  min-width: 90px;\n  text-align: center;\n  display: inline-block;\n  line-height: 31px;\n  font-weight: 400;\n  max-width: 90px;\n  cursor: pointer;\n}\n", ""]);

// exports
